import React, { Component, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getList, showUpdate, showDelete } from './unidadeAction'
import ReactPaginate from 'react-paginate';
import Grid from '../common/layout/grid'

class UnidadeList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            tipoPesq: '', valorPesq: '', enableInputPesquisa: true, itensPorPag: 16,
            pageCount: 0
        }


    }

    componentWillMount() {
        this.props.getList('', '', this.props.usuario.unidade)


    }

    getStatus(status) {
        return status ? 'Ativo' : 'Inativo'
    }

    renderRows() {
        if(this.props.list === undefined ) {return};
        const list = this.props.list.rows || []

        return list.map(bc => (
            <tr key={bc.id}>
                <td>{bc.nome} </td>
                <td>{bc.nome_fantasia} </td>
                <td >{this.getStatus(bc.ativo)} </td>
                <td>
                    <button className='btn btn-warning' onClick={() => this.props.showUpdate(bc)}>
                        <i className="fa fa-pencil"></i>
                    </button>
                    <button className='btn btn-danger' onClick={() => this.props.showDelete(bc)}>
                        <i className="fa fa-trash-o"></i>
                    </button>
                </td>
            </tr>
        ))
    }

    setItensPorPag = e => {
        this.setState({ ...this.state, itensPorPag: e.target.value })

    }

    setValorTipoPesquisa = e => {
        let tipoPesquisa = e.target.value
        if (tipoPesquisa === "") {
            this.setState({ ...this.state, tipoPesq: e.target.value, enableInputPesquisa: true, valorPesq: "" });
        } else {
            this.setState({ ...this.state, tipoPesq: e.target.value, enableInputPesquisa: false });
        }

    }

    setValorPesquisa = e => {
        this.setState({ ...this.state, valorPesq: e.target.value });
    }

    handlePageClick = async (data) => {
        let selected = data.selected;
        //await console.log('selected' + selected)
        let offset = Math.ceil(selected * this.state.itensPorPag);

        this.setState({ offset: offset }, () => {
            //this.loadCommentsFromServer();
            this.props.getList(this.state.tipoPesq, this.state.valorPesq, this.props.usuario.unidade, offset, this.state.itensPorPag)
        });
    };

    render() {

        return (
            <div>
                <div>
                    <div className="col-md-6">
                        <label>Pesquisa</label>
                        <div id="custom-search-input">
                            <div className="input-group col-md-12">
                                <span className="input-group-btn">
                                    <select className="btn btn-info btn-sm" id="tipo" name="tipo" onChange={this.setValorTipoPesquisa}>
                                        <option value="">Todos</option>
                                        <option value="id" >Id</option>
                                        <option value="nome" >Nome</option>
                                        <option value="nome_fantasia">Nome Fantasia</option>
                                    </select>

                                </span>
                                <div className="input-group col-md-12">
                                    <input type="text" className="form-control input-sm" placeholder="Buscar" value={this.state.valorPesq} onChange={this.setValorPesquisa} readOnly={this.state.enableInputPesquisa} />
                                    <span className="input-group-btn">
                                        <button className="btn btn-info btn-sm" type="button" onClick={() => this.props.getList(this.state.tipoPesq, this.state.valorPesq, this.props.usuario.unidade)}>
                                            <i className="glyphicon glyphicon-search"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Nome Fantasia</th>
                                <th>Status</th>
                                <th className='table-actions'>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}

                        </tbody>
                        <tfoot>

                        </tfoot>
                    </table>

                </div>
                <hr />
                <div>

                    <ReactPaginate
                        previousLabel="Anterior"
                        nextLabel="Próximo"
                        breakLabel="..."
                        breakClassName="break-me"
                        pageCount={this.props.list === undefined ? 0 : Math.ceil(this.props.list.count / this.state.itensPorPag)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName="pagination"
                        activeClassName="active"
                    />

                    <div className="div_right">
                        <label class="select-inline" for="qtdPorPag" >Qtd.Registro por Pág.
                            &nbsp;
                            <select id="qtdPorPag" onChange={this.setItensPorPag} className="mdb-select md-form colorful-select dropdown-primary">
                                <option value="16">16</option>
                                <option value="32" >32</option>
                                <option value="64">64</option>
                                <option value="128">128</option>
                                <option value="192">192</option>
                            </select>
                        </label>

                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => ({ list: state.unidade.list, usuario: state.auth.user })
const mapDispatchToProps = dispath => bindActionCreators({ getList, showUpdate, showDelete }, dispath)
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeList)


// WEBPACK FOOTER //
// ./src/unidade/unidadeList.jsx